import { createSlice } from "@reduxjs/toolkit";
import { IEventDetailsSlice } from "../../../models/student/studentCourceDetail";

const InitialEventDetails: IEventDetailsSlice = {
  eventDetails: undefined,
};

const eventDetailSlice = createSlice({
  name: "eventDetail",
  initialState: InitialEventDetails,
  reducers: {
    setEventDetails: (state, action: { payload: any }) => {
      state.eventDetails = action.payload;
    },
  },
});

export const { setEventDetails } = eventDetailSlice.actions;


const eventDetailReducer = eventDetailSlice.reducer;

export type eventDetailState = ReturnType<typeof eventDetailReducer>;

export default eventDetailReducer;



